import { Component, ElementRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { BaseModalPageComponent } from '../../../base-modal.component';
import { ModalComponent } from '../../../modal/modal.component';
import { Inspection } from '../../../shared/models';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { InspectionService, DataService } from '../../services';
import { SnackBarService } from '../../services/snack-bar.service';

@Component({
    selector: 'parts-management-modal',
    templateUrl: 'parts-management-modal.component.html',
    standalone: false
})
export class InspectionPartsManagementModalComponent extends BaseModalPageComponent {
  statuses = [];
  inspection: Inspection;
  @ViewChild('pricesInput', { static: true })
  pricesInput: ElementRef;
  @ViewChild('quotationInput', { static: true })
  quotationInput: ElementRef;
  @ViewChild('extractReportConfirm', { static: true })
  extractReportConfirm: ConfirmComponent;
  sapPricesAvailable = true;
  lastSynchronization = new Date();

  constructor(
    public selfModal: ModalComponent,
    location: Location,
    public inspectionService: InspectionService,
    public dataService: DataService,
    public snackBar: SnackBarService
  ) {
    super(location);
  }

  public init(data: any) {
    Object.assign(this, data);
    this.dataService.getPartsPlugin(this.inspection.id).subscribe((plugin) => {
      this.statuses = plugin.config.Statuses;
      this.lastSynchronization = plugin.config.LastSynchronization;
    });

    if (this.isManager)
      this.inspectionService.checkSapPrices(this.inspection.id).subscribe((res) => (this.sapPricesAvailable = res.available));
  }

  get country() {
    return this.inspection.insptectionInspectionCustomer.Country;
  }

  downloadPartsReport() {
    this.inspectionService.downloadReportByType(this.inspection.id, 300);
  }

  downloadMyBobstParts() {
    this.inspectionService.exportMyBobstCsvParts(this.inspection.id);
  }

  openPricesSelector() {
    this.pricesInput.nativeElement.click();
  }

  openQuotationSelector() {
    this.quotationInput.nativeElement.click();
  }

  uploadPartPrices(e: any) {
    const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    if (files && files.length > 0) {
      const inputFile = new FormData();
      for (let i = 0; i < files.length; i++) {
        inputFile.append(`files[${i}]`, files[i], files[i].name);
      }

      this.inspectionService.uploadPartsPrices(this.inspection.id, inputFile).subscribe((data) => {
        this.snackBar.success('snack-bar.success.parts-imported');
      });
    }
  }

  uploadQuotation(e: any) {
    const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    if (files && files.length > 0) {
      const inputFile = new FormData();
      for (let i = 0; i < files.length; i++) {
        inputFile.append(`files[${i}]`, files[i], files[i].name);
      }

      this.inspectionService.uploadQuotation(this.inspection.id, inputFile).subscribe((plugin) => {
        this.statuses = plugin.config.Statuses;
        this.snackBar.success('snack-bar.success.parts-imported');
      });
    }
  }

  synchronize() {
    this.inspectionService.synchronizeSap(this.inspection.id).subscribe((plugin) => {
      this.statuses = plugin.config.Statuses;
      this.lastSynchronization = plugin.config.LastSynchronization;
      this.snackBar.success('snack-bar.success.parts-imported');
    });
  }

  dismiss() {
    this.inspectionService.dismissPartStatuses(this.inspection.id).subscribe((plugin) => {
      this.statuses = plugin.config.Statuses;
    });
  }

  openExtractReportConfirm() {
    this.extractReportConfirm.open();
  }
}
